import UrlClass from './url';

export const Url = new UrlClass();
export {
  ALL_FOLDER_ID,
  SCRAPS_FOLDER_ID,
  ALL_FOLDER_NAME,
  SCRAPS_FOLDER_NAME,
} from './url';
export {
  URLS,
  PROJECTS,
  USER_PROFILE_SECTION_PATHS,
  USER_PROFILE_POSTS_SUB_PATHS,
  USER_PROFILE_SHOP_SUB_PATHS,
  USER_PROFILE_BACKROOM_SECTIONS,
  CHECKOUT_IDS,
  CONTACT_PAGE_ANCHOR_JUMP_POINTS,
  SHOP_PATHS,
  DEVIATION_PAGE_LANDING_ACTION,
  DEVIATION_PATHS,
} from './constants';

export const expressMiddleware =
  (environmentFlags: string[]) => (req, res, next) => {
    // Init the URL config this manages how urls are generated!
    // In dev mode we want links written back but not all links
    Url.initServerSide(req);

    Url.setEnv(
      process.env.NODE_ENV !== 'development' && process.env.XHR_ENV !== 'vm',
      environmentFlags
    );
    next();
  };
